import { IconButton, InputAdornment } from "@mui/material";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { useState } from "react";
import Input from "../ui/Input";

const PasswordInput = ({ label = "Password", ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Input
      type={showPassword ? "text" : "password"}
      label={label}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
              sx={{
                color: "#666666",
                marginRight: "0",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              {showPassword ? (
                <IconEyeOff size={16} color="#00000040" />
              ) : (
                <IconEye size={16} color="#00000040" />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};

export default PasswordInput;
